// extracted by mini-css-extract-plugin
export var printerCard = "_ak-1";
export var printerCardConfigured = "_ak-2";
export var printerCardError = "_ak-3";
export var printerCardsContainer = "_ak-0";
export var printerIcon = "_ak-8";
export var printerIconConfigured = "_ak-5";
export var printerIconContainer = "_ak-4";
export var printerIconError = "_ak-6";
export var printerIconUnconfigured = "_ak-7";